import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-info card-outline" }
const _hoisted_2 = { class: "card-header d-flex" }
const _hoisted_3 = { class: "mr-2" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "mx-auto text-center py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.collectionInfo.name), 1),
        _createElementVNode("h5", {
          innerHTML: _ctx.renderOption(_ctx.CollectionSelectOptions.Type, _ctx.collectionInfo.type)
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_app_button, {
          name: "Collection Detail",
          icon: "fa-eye",
          theme: "info",
          to: {
                    name: _ctx.ROUTE_NAME_COLLECTION.DETAIL(_ctx.collectionInfo.type),
                    params: { collectionId: _ctx.collectionInfo.id }
                }
        }, null, 8, ["to"]),
        _createVNode(_component_app_button, {
          name: _ctx.collectionInfo.btnAddLabel,
          icon: "fa-plus",
          theme: "info",
          to: {
                    name: _ctx.ROUTE_NAME_COLLECTION.ITEM.ADD(_ctx.collectionInfo.type),
                    params: { collectionId: _ctx.collectionInfo.id }
                }
        }, null, 8, ["name", "to"])
      ])
    ]),
    _createVNode(_component_app_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_app_table, {
          columns: _ctx.table.columns,
          rows: _ctx.list,
          total: _ctx.total,
          actions: _ctx.table.actions,
          onRefreshData: _ctx.fetchList
        }, null, 8, ["columns", "rows", "total", "actions", "onRefreshData"])
      ]),
      _: 1
    })
  ], 64))
}